import Select from "react-select";
import { useEffect, useState } from "react";
import { useProductOptions } from "../../../hooks/useProductOptions";
import "./styles.css";
import useServicesStore from "../../../store/servicesStore";
import { TableServices } from "../TableServices";
import { handleKeyDown } from "../../../utils/forms.util";

export const FormToAddService = () => {
    const [productSelected, setProductSelected] = useState([]);
    const [priceSelected, setPriceSelected] = useState("");
    const [pricesOptions, setPricesOptions] = useState([]);
    const { productOptions } = useProductOptions();
    const { addService } = useServicesStore();

    const handleClick = () => {
      try {
        const quantity = document.getElementById("quantityService");
        if (!(priceSelected && quantity.value && productSelected)) {
          return;
        }
        const newService = {
          serviceId: productSelected.id,
          name: productSelected?.name,
          price: priceSelected,
          quantity: quantity.value,
          code: productSelected?.code,
          description: productSelected?.description,
        };
        addService(newService);
        quantity.value = "";
        setProductSelected([]);
        setPricesOptions([]);
        setPriceSelected("");
      } catch (error) {
        console.log("error", error);
      }
    }

    useEffect(() => {
      setPriceSelected(pricesOptions?.price_list?.[0].value);
    }, [pricesOptions]);


    return (
      <>
        <div className="text-center">
          <span className="panel-title">
            <strong>Datos relacionados con el servicio</strong>
          </span>
          <br />
          <br />
        </div>
        <div className="row">
          <div className="col-md-6 pl-3 pr-3">
            <label>Servicio</label>
            <div className="input-group input--services mb-3">
              <div className="input-group-append input-group-text rounded-0 rounded-right">
                <span className="fas fa-building"></span>
              </div>
              <Select
                value={productSelected}
                // onInputChange={(value) => {
                //   if (value.includes(" ")) getProductByQuery(value);
                // }}
                onKeyDown={handleKeyDown}
                onChange={(e) => {
                  setProductSelected(e);
                  setPricesOptions(e?.prices[0] ?? []);                  
                }}
                options={productOptions}
                isClearable
                placeholder="Seleccione el servicio deseado ..."
              />
            </div>
          </div>
          <div className="col-md-6 pl-3 pr-3">
            <label>Cantidad</label>
            <div className="input-group mb-3">
              <select
                style={{display: "none"}}
                value={priceSelected}
                className="form-control"
                name="priceService"
                id="priceService"
                onChange={(e) => setPriceSelected(e.target.value)}
                required
                disabled={!pricesOptions?.price_list?.length}
              >
                <option value="">Precio...</option>
                {pricesOptions?.price_list?.map((option) => (
                  <option key={option.value + option.name} value={option.value}>
                    {option.value}
                  </option>
                ))}
              </select>
              <input
                type="number"
                className="form-control"
                name="quantityService"
                id="quantityService"
                autoComplete="off"
                placeholder="Cantidad"
                disabled={!(pricesOptions?.price_list?.length && priceSelected)}
                required
                min={1}
              />
              <div
                className={`input-group-append input-group-text rounded-0 rounded-right  
                ${
                  pricesOptions?.price_list?.length &&
                  priceSelected &&
                  "btn btn-success bg-success"
                }`}
                onClick={handleClick}
              >
                <span className="fas fa-plus"></span>
              </div>
            </div>
          </div>
          <div className="col-md-12 pl-3 pr-3">
            <TableServices />
          </div>
          <div className="col-md-6 pl-3 pr-3">
            <label>Observaciones</label>
            <div className="input-group mb-3">
              <div className="input-group-append input-group-text rounded-0 rounded-right">
                <span className="fab fa-unity"></span>
              </div>
              <textarea
                className="form-control"
                id="observations"
                name="observations"
                rows="4"
                cols="50"
              ></textarea>
            </div>
          </div>

          <div className="col-md-6 pl-3 pr-3">
            <label>Pendientes</label>
            <div className="input-group mb-3">
              <div className="input-group-append input-group-text rounded-0 rounded-right">
                <span className="fas fa-store"></span>
              </div>
              <textarea
                type="text"
                className="form-control"
                name="pending"
                id="pending"
                rows="4"
                cols="50"
                required
              />
            </div>
          </div>
        </div>
      </>
    );
};
